const GENRE_TRANSLATION_KEYS = {
  Fiction: 'onboarding.stepOne.genres.fiction',
  Novels: 'onboarding.stepOne.genres.novels',
  Fantasy: 'onboarding.stepOne.genres.fantasy',
  'Sci-Fi': 'onboarding.stepOne.genres.sciFi',
  Mystery: 'onboarding.stepOne.genres.mystery',
  Romance: 'onboarding.stepOne.genres.romance',
  Business: 'onboarding.stepOne.genres.business',
  'Self-Help': 'onboarding.stepOne.genres.selfHelp',
  'Memoir/Bio': 'onboarding.stepOne.genres.memoirBio',
  History: 'onboarding.stepOne.genres.history',
  'Science/Tech': 'onboarding.stepOne.genres.scienceTech',
  'Non-Fiction': 'onboarding.stepOne.genres.nonFiction',
  Biography: 'onboarding.stepOne.genres.memoirBio',
  Other: 'onboarding.stepOne.genres.other',
};

const PROJECT_STATUS_TRANSLATION_KEYS = {
  drafting: 'projects.bookStages.drafting',
  revising: 'projects.bookStages.revising',
  editing: 'projects.bookStages.editing',
  betaReading: 'projects.bookStages.betaReading',
  finalReview: 'projects.bookStages.finalReview',
  published: 'projects.bookStages.published',
};

const TRANSLATION_STATUS_KEYS = {
  translated: 'translationStudio.translated',
  translating: 'translationStudio.translating',
  failed: 'translationStudio.failed',
  pending: 'translationStudio.pending',
  stale: 'translationStudio.stale',
  untranslated: 'translationStudio.untranslated',
};

const SYSTEM_FOLDER_KEYS = {
  Chapters: 'sidebar.systemFolders.chapters',
  Characters: 'sidebar.systemFolders.characters',
  'World Building': 'sidebar.systemFolders.worldBuilding',
  Notes: 'sidebar.systemFolders.notes',
};

export function normalizeProjectStatusValue(status) {
  if (!status) return '';

  switch (status) {
    case 'Beta Reading':
      return 'betaReading';
    case 'Final Review':
      return 'finalReview';
    default:
      return String(status)
        .trim()
        .replace(/[\s_-]+(.)?/g, (_, char) => (char ? char.toUpperCase() : ''))
        .replace(/^./, (char) => char.toLowerCase());
  }
}

export function getTranslatedGenre(t, genre) {
  const key = GENRE_TRANSLATION_KEYS[genre];
  return key ? t(key, genre) : genre;
}

export function getTranslatedProjectStatus(t, status) {
  const normalized = normalizeProjectStatusValue(status);
  const key = PROJECT_STATUS_TRANSLATION_KEYS[normalized];
  return key ? t(key, status) : status;
}

export function formatRelativeTimeCompact(t, timestamp) {
  if (!timestamp) return '';

  const diff = Date.now() - timestamp;
  const minutes = Math.floor(diff / 60000);

  if (minutes < 1) return t('common.justNow');
  if (minutes < 60) return t('common.mAgo', { count: minutes });

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t('common.hAgo', { count: hours });

  const days = Math.floor(hours / 24);
  if (days < 7) return t('common.dAgo', { count: days });

  const weeks = Math.floor(days / 7);
  if (weeks < 5) return t('common.wAgo', { count: weeks });

  const months = Math.floor(days / 30);
  return t('common.moAgo', { count: months });
}

export function formatChatTimestamp(t, i18n, timestamp) {
  if (!timestamp) return '';

  const diff = Date.now() - timestamp;
  const minutes = Math.floor(diff / 60000);

  if (minutes < 1) return t('common.justNow');
  if (minutes < 60) return t('common.mAgo', { count: minutes });

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t('common.hAgo', { count: hours });

  const days = Math.floor(hours / 24);
  if (days < 7) return t('common.dAgo', { count: days });

  return new Intl.DateTimeFormat(i18n.language || undefined, {
    month: 'short',
    day: 'numeric',
  }).format(new Date(timestamp));
}

export function formatMonthShort(i18n, date) {
  return new Intl.DateTimeFormat(i18n.language || undefined, { month: 'short' }).format(date);
}

export function getAchievementTitle(t, achievementId, fallback) {
  return t(`achievements.items.${achievementId}.title`, fallback);
}

export function getAchievementDescription(t, achievementId, fallback) {
  return t(`achievements.items.${achievementId}.description`, fallback);
}

export function getTranslationStatusLabel(t, status) {
  const key = TRANSLATION_STATUS_KEYS[status];
  return key ? t(key, status) : status;
}

export function getSystemFolderLabel(t, name) {
  const key = SYSTEM_FOLDER_KEYS[name];
  return key ? t(key, name) : name;
}

export function translateProjectPath(t, path) {
  if (!path) return path;

  const segments = String(path).split('/');
  if (segments.length === 0) return path;

  const [root, ...rest] = segments;
  return [getSystemFolderLabel(t, root), ...rest].join('/');
}
